export default "__VITE_ASSET__BzHiEqdn__"